module.exports = "../fonts/transfer_location.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/transfer_location.svg
// module id = 354
// module chunks = 0